import sanityClient from '@sanity/client';

const client = sanityClient({
    projectId: process.env.GATSBY_SANITY_PROJECT_ID,
    dataset: process.env.GATSBY_SANITY_DATASET,
    useCdn: false,
});

export const getLineItemsTitle = async (items) => {
    const validItems = items.filter(item => item?.variant?.product?.id);
    if (validItems.length === 0) return items;

    const formattedItems = validItems.map(getShopifyIdFromSanityId).map(item => `"${item}"`).join(',');

    let getProductCartTitle = [];
    try {
        getProductCartTitle = await client.fetch(`
            *[_type == "productsShopify" && _id in [${formattedItems}]]{
                ...
            }
        `);
    } catch (e) {
        console.error("Error fetching Sanity cart titles", e);
    }

    return items.map(t => {
        if (!t?.variant?.product?.id) return t;

        const shopifyId = getShopifyIdFromSanityId(t);
        const item = getProductCartTitle.find(_item => _item._id == shopifyId);
        if (item) {
            return { ...t, content: item.content };
        }
        return t;
    });
}

export const getShopifyIdFromSanityId = (item) => {
    if (item?.variant?.product?.id) {
        return item.variant.product.id.replace("gid://shopify/Product/", "products-");
    }
    return "";
};
